import { updateEntity } from "../CommonAPI";
import { FETCH_THIRDPARYDATA_DETAIL_BEGIN, FETCH_THIRDPARYDATA_DETAIL_FAILURE, FETCH_THIRDPARYDATA_DETAIL_SUCCESS } from "../constants/thirdPartyData";

export const getThirdPartyDataDetailsDetailAction=({Id,ThirdPartyDataDetails})=>{
    return (dispatch) => {
        dispatch(fetchThirdPartyDataDetailsDetailBegin());
        dispatch(fetchThirdPartyDataDetailsDetailSuccess(ThirdPartyDataDetails));
        updateEntity("ThirdPartyDataId",Id);
        return ThirdPartyDataDetails;
    };
};
const fetchThirdPartyDataDetailsDetailBegin = () => ({
    type: FETCH_THIRDPARYDATA_DETAIL_BEGIN,
});
const fetchThirdPartyDataDetailsDetailSuccess = (ThirdPartyDataDetails) => (
   {
    type: FETCH_THIRDPARYDATA_DETAIL_SUCCESS,
    payload: { ThirdPartyDataDetails },
});
const fetchThirdPartyDataDetailsDetailFailure = (errorMessage) => ({
    type: FETCH_THIRDPARYDATA_DETAIL_FAILURE,
    payload: { errorMessage }
}); 

